import React from "react";
import { useTranslation } from "react-i18next";
import HardwareSignupCard from "../../../HardwareSignupCard/HardwareSignupCard";

const DisplayPlanLength = (props) => {
  const { handleSelectionChange, selectedData, planLengths } = props;
  const { t } = useTranslation(["translation"]);

  return (
    <div className="cp-printer-feature-wrapper">
      <div className="cp-subtitle">
        {t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.PLAN_LENGTH.HEADER")}
      </div>
      <div className="cp-card">
        {planLengths.map((length, index) => (
          <HardwareSignupCard
            key={index}
            onHardwarePlanSelection={handleSelectionChange}
            selectedCard={selectedData}
            toCompareSelectedCardWith={`${length}`}
            cardRightData={`${length} ${t(
              "HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.PLAN_LENGTH.MONTHS"
            )}`}
          />
        ))}
      </div>
    </div>
  );
};

export default DisplayPlanLength;
